import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Loader from 'components/Loader';
import { getChargebeeSubscription } from 'redux/actions/subscriptionActions';
import { dispatchError } from 'redux/actions/messageActions';
import Router from './routes/Router';
import { useManagedServiceSignupGuard } from './utils/routing';


const styles = theme => ({
  '@global': {
    main: {
      padding: '0 !important',
    },
    body: {
      color: `${theme.palette.secondary.text} !important`,
      margin: '0 !important',
      padding: '0 !important',
      boxSizing: 'border-box !important',
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: '1rem !important',
      lineHeight: '1.6 !important',
    },
    '*': {
      boxSizing: 'inherit !important',
    },
    'ul, ol': {
      paddingLeft: '15px',
      marginBottom: '0 !important',
    },
    hr: {
      borderTop: `1px solid ${theme.palette.secondary['100']} !important`,
    },
    a: {
      color: `${theme.palette.secondary['900']}`,
      transition: 'all 0.3s',
      '&:hover': {
        textDecoration: 'none',
        color: `${theme.palette.secondary['800']}`,
      },
    },
    '.tox-statusbar__branding': {
      display: 'none',
    },
    '.tox-notification--error': {
      display: 'none !important',
    },
    '.tox-collection__group:has(div[title="New document"])': {
      display: 'none',
    },
    '.tox-collection__group:nth-of-type(2)': {
      borderTop: 'none !important',
    },
    'div[role="navigation"].tox-statusbar__path': {
      display: 'none',
    },
    '.tox-collection__group:has(div[title="Code"])': {
      display: 'none',
    },
    '.tox-collection__group div[title="Horizontal line"]': {
      display: 'none',
    },
  },
});

const GlobalStylesWrapper = (props) => {
  const {
    subscription, location, history,
  } = props;
  const checking = useManagedServiceSignupGuard(
    location,
    subscription,
    history,
    props.getChargebeeSubscription,
    props.dispatchError,
  );

  const { pathname } = location;
  const permsLoading = !pathname.includes('login') &&
   !pathname.includes('signup') &&
   pathname !== '/' &&
   props.canSeeCoverage === undefined &&
   props.isAuthenticated;

  return (
    <div>
      <Loader loading={props.loading || checking || permsLoading}>
        <Router childProps={props} />
      </Loader>
    </div>
  );
};

GlobalStylesWrapper.propTypes = {
  loading: PropTypes.bool.isRequired,
  getChargebeeSubscription: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  subscription: PropTypes.shape({}).isRequired,
  dispatchError: PropTypes.func.isRequired,
  canSeeCoverage: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
};

GlobalStylesWrapper.defaultProps = {
  canSeeCoverage: undefined,
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(
    state => ({
      subscription: state.subscription,
    }),
    { getChargebeeSubscription, dispatchError },
  ),
)(GlobalStylesWrapper);
